
// Angular
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
// 3rdparty
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, catchError, combineLatest, filter, forkJoin, skip, takeUntil, throwError } from 'rxjs';
// Hostware
import { BalanceType } from '@app/types/Types';
import { Balance } from '@app/interfaces/Balance';
import { SubscriberParameterService } from '../../../../../froexishared/src/services/SubscriberParameter.service';
import SessionStorage from '@app/helpers/SessionStorage';
import { SubscriberParameter } from '../../../../../froexishared/src/dto/SubscriberParameter';
import { CurrencySettings } from '../../../../../froexishared/src/dto/CurrencySettingsDto';
import { BillingService } from '@app/services/billing.service';
import { RoomGuest } from '@app/dto/ReservationInfo';
import { Charge, PayValueWrapper, RoomStayCharge, StartBillingResponse } from '@app/interfaces/StartBillingResponse';
import { SpinnerService } from '@app/services/spinner.service';

import { GenericMessageDialogComponent } from '../../dialogs/generic-message-dialog/generic-message-dialog.component';
import { GenericMessage } from '@app/interfaces/generic-message';
import dayjs from 'dayjs';
import { HeaderService } from '@app/services/header.service';
import { HwServicesService } from '../../../../../froexishared/src/services/hw-services.service';

import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { ServiceEditable } from '../../../../../froexishared/src/dto/Service';
import { formatCurrency, formatNumber } from '@angular/common';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { ServiceLight } from '@app/interfaces/ServiceLight';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
@Component({
  selector: 'app-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})

@AutoUnsubscribe()
export class BalanceComponent implements OnInit, OnDestroy {

  loadBalance$: Subscription;
  destroy$: Subject<boolean> = new Subject<boolean>();

  startBillingRespose: StartBillingResponse;
  dataSource: MatTableDataSource<Balance>;


  queryParams: Params;
  showDeposit: boolean = false;
  loaded: boolean = false;
  currencySettings: CurrencySettings;
  total: number = 0
  paymentDisabled: boolean;
  sumDeposit: number = 0;
  isEur: boolean;
  exchangeRate: number = 1;
  selectedCurrency: string;
  hufTotal: number = 0;
  eurTotal: number = 0;
  hufDeposit: number = 0;
  eurDeposit: number = 0;

  eurSzallasEurDeposit: boolean;
  eurSzallasHufDeposit: boolean;
  hufSzallasHufDeposit: boolean;
  showVoucherWarning: boolean;
  invoiceCurrency: string
  balanceErrorMessage: string;
  noOutstandingItemMessage: string;


  filtered: RoomStayCharge[];
  services: ServiceEditable[] = [];
  excludedServices: ServiceEditable[] = []
  usedExcludedServices: ServiceEditable[] = [];
  excludedServiceNames: ServiceLight[] = [];

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  hasEurPayment = SessionStorage.HasEurPayment

  constructor(

    private router: Router,
    private translate: TranslateService,
    private subscriberParamaterService: SubscriberParameterService,
    private activatedRoute: ActivatedRoute,
    private billingService: BillingService,
    private spinnerService: SpinnerService,
    private headerService: HeaderService,
    private hwServicesService: HwServicesService,
    private errorDialog: MatDialog,
    private dialog: MatDialog,
    public sessionStorageService: SessionstorageService,
    private chatService: ChatService

  ) { }

  //#region =============== Angular Lifecyle events ============================================================================
  ngOnInit() {
    if (!this.hasEurPayment) {

      this.selectedCurrency = "HUF";
      SessionStorage.Currency = "HUF";
      
    }
    this.balanceErrorMessage = this.translate.instant('balance.deposit_error')
    this.noOutstandingItemMessage = this.translate.instant('balance.no_outstanding_item')
    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })

    // charge összegzés
    this.hufTotal = 0;
    this.eurTotal = 0;
    this.hufDeposit = 0;
    this.eurDeposit = 0;
    this.showDeposit = true //this.queryParams["showdeposit"] == "true" ? true : false;

    const selectedGuest = JSON.parse(sessionStorage.getItem('sgd')) as RoomGuest
    const selectedLanguage = SessionStorage.ActiveLanguage;

    this.spinnerService.setSpinnerVisibility(true);

    // megnézzük nincs-e lockolva a számla 

    let startBillingError: string = ""

    const combinedSources = forkJoin({
      startbillingResponse: this.billingService.StartBilling(selectedGuest.GuestStayUuId, SessionStorage.ActiveLanguage, true).pipe(
        catchError(err => {
          err.source = 'startbilling'
          return throwError(() => err)
        })
      ),
      subscriberParameters: this.subscriberParamaterService.loadAll(SessionStorage.ReservationInfo.Subscriber, parseInt(SessionStorage.ReservationInfo.Hotelid)),
      services: this.hwServicesService.getServices(SessionStorage.ReservationInfo.Subscriber, parseInt(SessionStorage.ReservationInfo.Hotelid))

    }).pipe(takeUntil(this.destroy$)).subscribe({
      next: (values) => {
        this.services = values.services as ServiceEditable[];
        this.startBillingRespose = values.startbillingResponse as StartBillingResponse;

        this.invoiceCurrency = this.startBillingRespose.Transaction.InvoiceCurrency;
        SessionStorage.Currency = this.startBillingRespose.Transaction.InvoiceCurrency;
        this.switchCurrency(SessionStorage.Currency);
        this.currencySettings = JSON.parse((values.subscriberParameters as SubscriberParameter[]).find(item => item.Param_Typecode == "CURRENCY_SETTINGS").Param_Json_Value) as CurrencySettings // values.currencySettings as SubscriberParameter;
        this.showVoucherWarning = (values.subscriberParameters as SubscriberParameter[]).find(item => item.Param_Typecode == "VOUCHER_WARNING").Param_Int_Value == 0 ? false : true
        let hasExcludedServices: boolean = false;
        let hasOnlyExcludedServices: boolean = true;
        SessionStorage.HasExludedService = 'n';
        SessionStorage.HasOnlyExludedServices = 'n'
        this.excludedServices = [];
        this.excludedServiceNames = [];
        this.services.forEach(item => {
          if (item.ExcSzep) {
            this.excludedServices.push(item)
          }
        })
        this.usedExcludedServices = [];
        this.excludedServices.forEach(excluded => {
          this.startBillingRespose.Transaction.RoomStayCharges.forEach(charges => {
            charges.GuestStayCharges.forEach(gguestCharge => {
              gguestCharge.GuestCharges.forEach(ggguestCharge => {
                if (ggguestCharge.ServiceId == excluded.ServiceId.toString()) {
                  this.usedExcludedServices.push(excluded)
                }
                if (ggguestCharge.ServiceId == excluded.ServiceId.toString() && !hasExcludedServices) {
                  hasExcludedServices = true;
                }
              });
            })
            charges.RoomStayCharges.forEach(roomstayCharge => {
              if (roomstayCharge.ServiceId == excluded.ServiceId.toString()) {
                this.usedExcludedServices.push(excluded)
              }
              if (roomstayCharge.ServiceId == excluded.ServiceId.toString() && !hasExcludedServices) {
                hasExcludedServices = true
              }
            })
          })
        })
        hasOnlyExcludedServices = true;
        this.startBillingRespose.Transaction.RoomStayCharges.forEach(charges => {
          charges.GuestStayCharges.forEach(gguestCharge => {
            gguestCharge.GuestCharges.forEach(ggguestCharge => {
              if (!this.excludedServices.find(item => item.ServiceId.toString() == ggguestCharge.ServiceId) && hasOnlyExcludedServices) {
                hasOnlyExcludedServices = false;
              }
            });
          })
          charges.RoomStayCharges.forEach(roomstayCharge => {
            if (!this.excludedServices.find(item => item.ServiceId.toString() == roomstayCharge.ServiceId) && hasOnlyExcludedServices) {
              hasOnlyExcludedServices = false
            }
          })
        })

        this.usedExcludedServices.forEach(item => {
          const name = item.LangDescriptions.find(item => item.Lang == SessionStorage.ActiveLanguage).ServiceDescription
          const found = this.excludedServiceNames.find(ex => ex.ServiceId == item.ServiceId)
          if (!found) {
            this.excludedServiceNames.push({ ServiceId: item.ServiceId, Description: name })
          }

        })
        if (this.excludedServiceNames.length > 0) {
          SessionStorage.ExcludedServiceNames = this.excludedServiceNames;
        } else {
          SessionStorage.ExcludedServiceNames = []
        }

        this.isEur = false;
        this.startBillingRespose.Transaction.RoomStayCharges.forEach(charge => {
          charge.RoomStayCharges.forEach(roomStayCharge => {
            if (roomStayCharge.Description?.trim().length == 0 || roomStayCharge.Description == null) {
              const huDescription = this.services.find(item => item.ServiceId.toString() == roomStayCharge.ServiceId).LangDescriptions
                .find(item => item.Lang == "hu").ServiceDescription;
              roomStayCharge.Description = huDescription
            }
          })
        })
        this.startBillingRespose.Transaction.RoomStayCharges.forEach(charge => {
          charge.GuestStayCharges.forEach(guestStayCharge => {
            guestStayCharge.GuestCharges.forEach(guestCharge => {
              if (guestCharge.Description?.trim().length == 0 || guestCharge.Description == null) {
                const huDescription = this.services.find(item => item.ServiceId.toString() == guestCharge.ServiceId).LangDescriptions
                  .find(item => item.Lang == "hu").ServiceDescription;
                guestCharge.Description = huDescription
              }
            })
          })
        })


        if (SessionStorage.Invited == "Y") {
          this.filtered = this.startBillingRespose.Transaction.RoomStayCharges.filter(item => item.RoomId == SessionStorage.RoomId)
        }
        else {
          this.filtered = this.startBillingRespose.Transaction.RoomStayCharges;
        }
        this.filtered.forEach(charge => {
          charge.RoomStayCharges.forEach(item => {
            this.hufTotal += (item.Amount)
            this.eurTotal += (item.InvoiceAmount)
          })
          charge.GuestStayCharges.forEach(guestStayCharge => {
            guestStayCharge.GuestCharges.forEach(item => {
              this.hufTotal += (item.Amount)
              this.eurTotal += (item.InvoiceAmount)
            })
          })
        })

        SessionStorage.HasExludedService = hasExcludedServices ? 'y' : 'n'
        SessionStorage.HasOnlyExludedServices = hasOnlyExcludedServices ? 'y' : 'n'
        this.startBillingRespose.Transaction.Deposits.forEach(deposit => {
          this.hufDeposit += deposit.Amount;
          this.eurDeposit += deposit.InvoiceAmount;
        })

        if (this.selectedCurrency == "HUF") {
          this.sumDeposit = this.hufDeposit
          this.total = this.hufTotal - this.sumDeposit
        } else {
          this.sumDeposit = this.eurDeposit;
          this.total = this.eurTotal - this.eurDeposit
        }
        if (this.total <= 0 || (!this.vatCheckOk(this.startBillingRespose))) {
          this.paymentDisabled = true;
        }
        this.loaded = true
        this.spinnerService.setSpinnerVisibility(false);
        this.headerService.setNavigationVisibility(true)
      },
      error: err => {
        this.spinnerService.setSpinnerVisibility(false);
        if (err.source == 'startbilling') {
          const reason = err.error.toString().trim();
          let messageText: string;
          switch (reason) {
            case "INVALID_HOTEL3PID":
              messageText = this.translate.instant('startbilling.invalid_hotel3pid');
              break;
            case "INVOICING_IN_PROGRESS":
              messageText = this.translate.instant('startbilling.invoicing_in_progress');
              break;
            case "INVOICING_LOCKED_BY_FRO":
              messageText = this.translate.instant('startbilling.invoicing_locked_by_fro');
              break;
            case "DIFFERENCE_IN_DEPOSIT":
              messageText = this.translate.instant('startbilling.difference_in_deposit');
              break;
            case "PROCESS_ERROR":
              messageText = this.translate.instant('startbilling.process_error');
              break;
            default: {
              messageText = this.translate.instant('common.network_error')
              break
            }
          }
          let messageData: GenericMessage = { messageText: messageText, messageType: 'ERROR', showIcon: true }
          const dialogRef = this.errorDialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "auto",
            data: messageData
          })
          dialogRef.afterClosed().subscribe(res => {
            this.spinnerService.setSpinnerVisibility(false);
            this.headerService.setNavigationVisibility(true);
            this.router.navigateByUrl('checkinstatus')
          })
        }

        // let messageData: GenericMessage = { messageText: this.translate.instant('common.network_error'), messageType: 'ERROR', showIcon: true }
        // const dialogRef = this.errorDialog.open(GenericMessageDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: messageData
        // })

      }
    })


  }
  ngOnDestroy(): void {
    this.loadBalance$?.unsubscribe();
  }
  //#endregion =================================================================================================================

  //#region =============== List event hadlers   ===============================================================================
  //#endregion =================================================================================================================

  //#region =============== Form events ========================================================================================

  forwardClick() {

    // check voucher
    const messageData = { messageText: this.translate.instant('balance.voucher_alert'), messageType: 'WARNING', showIcon: true }
    if (this.showVoucherWarning) {
      this.dialog.open(YesNoDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: messageData
      }).afterClosed().subscribe(data => {
        if (data) {
          SessionStorage.UseDeposit = "y";
          SessionStorage.Currency = this.selectedCurrency;
          this.router.navigateByUrl('/invoicedetails');
        } else {
          this.router.navigateByUrl('/checkinstatus');
        }

      })
    } else {
      SessionStorage.UseDeposit = "y";
      SessionStorage.Currency = this.selectedCurrency;
      this.router.navigateByUrl('/invoicedetails');
    }





  }

  navigateBack() {
    this.router.navigateByUrl('/checkinstatus')
  }

  navigateToWelcome() {
    this.router.navigateByUrl('/welcome')
  }

  //#endregion =================================================================================================================

  //#region =============== Dialog events ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Validation    ======================================================================================
  //#endregion =================================================================================================================

  //#region =============== Functions  =========================================================================================
  formattedDate(dateString: string): string {
    return dayjs(dateString).locale(SessionStorage.ActiveLanguage).format('ll');
  }

  currency(): string {
    return SessionStorage.Currency;
  }

  switchCurrency(currency: string): void {
    this.selectedCurrency = currency;

    if (this.selectedCurrency == "HUF") {
      this.sumDeposit = this.hufDeposit
      this.total = this.hufTotal - this.hufDeposit
    } else {
      this.sumDeposit = this.eurDeposit;
      this.total = this.eurTotal - this.eurDeposit
    }

  }

  amount(amountt: Charge): string {
    const locale = this.selectedCurrency == "HUF" ? "hu-HU" : "en-US";
    if (this.selectedCurrency == "HUF") {
      return formatNumber(amountt.Amount, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(amountt.InvoiceAmount, locale, "0.0-2").replace(".", ",");
    }
  }

  guestChargeAmout(guestCharge: Charge): string {
    const locale = this.selectedCurrency == "HUF" ? "hu-HU" : "en-US";
    if (this.selectedCurrency == "HUF") {
      return formatNumber(guestCharge.Amount, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(guestCharge.InvoiceAmount, locale, "0.0-2").replace(".", ",");
    }

  }

  totalAmount(): string {
    const locale = this.selectedCurrency == "HUF" ? "hu-HU" : "en-US";
    if (this.selectedCurrency == "HUF") {
      return formatNumber(this.total, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(this.total, locale, "0.0-2").replace(".", ",");
    }

  }

  deposit() {
    const locale = this.selectedCurrency == "HUF" ? "hu-HU" : "en-US";
    if (this.selectedCurrency == "HUF") {
      return formatNumber(this.hufDeposit, locale, "0.0-0").replace(",", " ");
    } else {
      return formatNumber(this.eurDeposit, locale, "0.0-2").replace(".", ",");
    }

  }
  roomId(): string {
    return SessionStorage.RoomId;
  }

  vatCheckOk(response: StartBillingResponse): boolean {
    let ret: boolean
    let diffFound: boolean;
    let depositSummaries: DepositSummary[] = [];

    depositSummaries.push({ Deposit: response.PayValues["0"]?.Deposit, Charge: 0, VatPercent: 0 })
    depositSummaries.push({ Deposit: response.PayValues["5"]?.Deposit, Charge: 0, VatPercent: 5 })
    depositSummaries.push({ Deposit: response.PayValues["27"]?.Deposit, Charge: 0, VatPercent: 27 })
    // RoomstayCharge summary
    response.Transaction.RoomStayCharges.forEach(roomStayCharge => {
      roomStayCharge.RoomStayCharges.forEach(rst => {
        depositSummaries.find(item => item.VatPercent == rst.TaxPercent).Charge += rst.Amount;
      })
    })
    //  GuestStayCharge summary 
    this.startBillingRespose.Transaction.RoomStayCharges.forEach(charge => {
      charge.GuestStayCharges.forEach(guestStayCharge => {
        guestStayCharge.GuestCharges.forEach(guestCharge => {
          depositSummaries.find(item => item.VatPercent == guestCharge.TaxPercent).Charge += guestCharge.Amount;
        })
      })
    })
    depositSummaries.forEach(item => {
      if (item.Deposit > item.Charge && !diffFound) {
        diffFound = true;
      }
    })
    return !diffFound
  }


  currencySwitchStyle() {
    let styles = {};
    if (this.hufDeposit != this.eurDeposit)

      // (InvoiceCurrency=EUR és az amount-HUF és InvoiceAmount-EUR különbözik)
      if (this.invoiceCurrency == "EUR" && this.hufDeposit !== this.eurDeposit) {
        styles["visibility"] = 'hidden'
        this.selectedCurrency = "EUR";
        SessionStorage.Currency = "EUR";
      }

    // EUR szállásdíj, HUF deposit (InvoiceCurrency=HUF és az amount=InvoiceAmount) - csak HUF-ban fizethet
    if (this.invoiceCurrency == "HUF" && this.hufDeposit !== this.eurDeposit) {
      styles["visibility"] = 'hidden'
      this.selectedCurrency = "HUF";
      SessionStorage.Currency = "HUF";
    }
    if (!this.hasEurPayment) {
      styles["visibility"] = 'hidden'
      this.selectedCurrency = "HUF";
      SessionStorage.Currency = "HUF";
      this.switchCurrency('HUF')
    }
    return styles
  }
  // balanceItemStyle(rst: RoomStayCharge) {
  //   let styles = {};
  //   styles["color"] = rst.Price > 0 ? 'black' : 'red'
  //   return styles;
  // }

  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  //#endregion =================================================================================================================

}

interface DepositSummary {
  VatPercent: number
  Deposit: number
  Charge: number
}

